import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../../components/common/Button';
import ListItem from '../../components/admin/ListItem';
import { ListItemContainer } from '../../components/admin/ListItem';

import { getApplicationList } from '../../lib/api/admin';
import { adminFieldState, adminIdState } from '../../lib/store/adminAtom';
import { useRecoilState } from 'recoil';

const AdminList = () => {
  const [isLogin, setIsLogin] = useState(!!localStorage.getItem('efub-token'));
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialFilter = queryParams.get('filter') || 'all';

  const [currentField, setCurrentField] = useRecoilState(adminFieldState);
  const [currentId, setCurrentId] = useRecoilState(adminIdState);
  const [selectedOption, setSelectedOption] = useState(
    initialFilter === 'all'
      ? '전체'
      : initialFilter === 'first'
        ? '1차'
        : '최종',
  );
  const [data, setData] = useState([]);

  const [buttons, setButtons] = useState([
    {
      id: 0,
      name: '프론트리드',
      query: 'DEVELOPER_LEAD_FRONT',
      state: currentField === 'DEVELOPER_LEAD_FRONT',
    },
    {
      id: 1,
      name: '프론트인턴',
      query: 'DEVELOPER_INTERN_FRONT',
      state: currentField === 'DEVELOPER_INTERN_FRONT',
    },
    {
      id: 2,
      name: '백리드',
      query: 'DEVELOPER_LEAD_BACK',
      state: currentField === 'DEVELOPER_LEAD_BACK',
    },
    {
      id: 3,
      name: '백인턴',
      query: 'DEVELOPER_INTERN_BACK',
      state: currentField === 'DEVELOPER_INTERN_BACK',
    },
    {
      id: 4,
      name: '디자이너',
      query: 'DESIGNER',
      state: currentField === 'DESIGNER',
    },
  ]);

  // 선택한 버튼 업데이트
  const _handleSelect = (index) => {
    const updatedButtons = buttons.map((item, idx) => ({
      ...item,
      state: idx === index,
    }));
    setButtons(updatedButtons);
  };

  // 현재 선택된 버튼 currentField에 반영
  useEffect(() => {
    const selected = buttons.find((item) => item.state);
    if (selected) setCurrentField(selected.query);
  }, [buttons]);

  // 드롭다운 값 변경 시 selectedOption 업데이트
  const handleDropdownChange = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    if (!isLogin) {
      navigate(`/${process.env.REACT_APP_ADMIN_PATH}`);
    }
  }, [isLogin]);

  useEffect(() => {
    const stage =
      selectedOption === '전체'
        ? 'all'
        : selectedOption === '1차'
          ? 'first'
          : 'final';

    if (currentField) {
      getApplicationList(stage, currentField).then((res) => {
        if (res) {
          setData(res);
          setCurrentId(res.map((item) => item.id));
        }
      });
    }
  }, [selectedOption, currentField]);

  return (
    <Wrapper>
      <TitleWrapper>
        <h1>
          <span>
            <Dropdown value={selectedOption} onChange={handleDropdownChange}>
              <option value="전체">전체</option>
              <option value="1차">1차</option>
              <option value="최종">최종</option>
            </Dropdown>
          </span>{' '}
          {selectedOption === '전체' ? '지원자 리스트' : '합격자 조회'}
        </h1>
      </TitleWrapper>
      <ButtonWrapper>
        {buttons.map((item, index) => (
          <Button
            round
            blue
            width="8"
            filled={item.state}
            onClick={() => _handleSelect(index)}
            key={item.id}
          >
            {item.name}
          </Button>
        ))}
      </ButtonWrapper>
      <ListBox>
        <ListTitle isPass={true}>
          <div>ID</div>
          <div>이름</div>
          <div>학번</div>
          <div>파트</div>
          <div>단대 및 학과</div>
          <div>면접 시간</div>
          <div>최종 합격</div>
        </ListTitle>
        {data ? (
          data.map((item) => (
            <ListItem
              key={item.id}
              isPass={item.finalRoundStatus}
              item={item}
              setData={setData}
            />
          ))
        ) : (
          <h1>error</h1>
        )}
      </ListBox>
    </Wrapper>
  );
};

export default AdminList;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5rem 0;
  font-family: Pretendard;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
`;

const Dropdown = styled.select`
  font-size: 1.5rem;
  padding: 0.75rem 0.5rem 0.75rem 1rem;
  margin-right: 0.5rem;
  border: none;
  border-radius: 8px;
  background-color: transparent;
  color: white;
  font-family: Pretendard;
  font-size: 2rem;
  font-weight: 600;
  cursor: pointer;
  outline: none;
  transition:
    background-color 0.3s,
    border-color 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.7);
  }

  & > option {
    background-color: rgba(0, 0, 0, 0.8);
    font-weight: 600;
    color: white;
  }

  & > option:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  padding: 50px 0 30px 0;
`;

const ListBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  background-color: rgba(255, 255, 255, 0.15);
  width: 100%;
  border-radius: 10px;
  padding-bottom: 10px;
`;

const ListTitle = styled(ListItemContainer)`
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  & div {
    height: 3.5rem;
    font-weight: 700 !important;
  }
`;
